// A manual refresh supersedes an earlier response; polling never overlaps it.
export function createAppListLoadGate() {
  let generation = 0;
  let inFlight = false;
  return {
    begin(poll: boolean): number | null {
      if (poll && inFlight) return null;
      inFlight = true;
      return ++generation;
    },
    isCurrent(request: number): boolean {
      return request === generation;
    },
    finish(request: number): void {
      if (request === generation) inFlight = false;
    },
    invalidate(): void {
      generation += 1;
      inFlight = false;
    },
  };
}

export function hasCompleteAppLifecycleStates(
  appIds: string[],
  states: ReadonlyMap<string, unknown>,
): boolean {
  return appIds.every((id) => states.has(id));
}
